import { useMemo, useContext, Fragment } from 'react';
import { BIMContext } from 'providers/bim-provider';
import { bimUploadTableHeaders as tableHeaders } from 'config';
import { FactDropdown, TrailFormula, AddNewFact } from '..';
import Images from 'assets/Images';
import { Popup } from 'components/generic';
import { useSelector } from 'react-redux';
import { isInteger } from 'lodash';

import './style.scss';

const UploadTable = () => {
	const context = useContext(BIMContext);
	const baseData = useSelector(state => ({ refData: state?.referenceData?.data, factList: state?.factList?.data }));
	const { createObj, setCreateObj, formulaIndex, addNewFactPopup, setFormulaIndex, setAddNewFactPopup } = context;
	const headers = tableHeaders?.map((el, i) => <th key={i}>{el?.value}</th>);

	// seting CreateObj
	const handleSelectFact = (e, i) => {
		setCreateObj(prevState => {
			const data = Object.assign({}, prevState);
			data.bfm_uploadDetails[i].bfm_desField = e?.fa_collection_field;
			data.bfm_uploadDetails[i].bfm_enableLinkPosition = e?.fa_mandatory?.includes('bfm_linkedSNo');
			data.bfm_uploadDetails[i].bfm_linkRefKey = e?.fa_mandatory?.includes('fa_refLink') ? e?.fa_refLink[0] : null;
			data.bfm_uploadDetails[i].bfm_linkRefList = e?.fa_mandatory?.includes('fa_refLink') ? baseData?.refData?.find(el => el?.key === e?.fa_refLink[0])?.value || [] : false;
			return data;
		});
	};

	// reference linkage handler
	const handleRefLink = (e, i) => {
		setCreateObj(prevState => {
			const data = Object.assign({}, prevState);
			data.bfm_uploadDetails[i][data.bfm_uploadDetails[i]?.bfm_linkRefKey] = e?.key;
			return data;
		});
	};

	// linked Position
	const linkedPositionHandler = (e, i) => {
		const value = Math.floor(e?.target?.value);
		setCreateObj(prevState => {
			const data = Object.assign({}, prevState);
			data.bfm_uploadDetails[i].bfm_linkedSNo = value || null;
			return data;
		});
	};

	const factDropdownComponent = (data, i) => <FactDropdown add none search title='Please Select The Destination Field' list={baseData?.factList} onChange={e => handleSelectFact(e, i)} value={data?.bfm_desField} index={i} />;

	// display the fields from table
	const displayFields = (data, header, i) => {
		const obj = {
			bfm_desField: () => factDropdownComponent(data, i),
			bfm_formula: () => formulaSection(data, i),
			bfm_linkedSNo: () => linkedPosition(data, i),
			bfm_refLink: () => data?.bfm_linkRefKey && data?.bfm_linkRefList?.length > 0 && <FactDropdown exact list={data?.bfm_linkRefList} onChange={e => handleRefLink(e, i)} value={data[data?.bfm_linkRefKey]} />,
			DEFAULT: () => data[header?.key]
		};
		return (obj[header?.key] || obj['DEFAULT'])();
	};

	// linking the Position
	const linkedPosition = (data, i) => {
		return <input className='upload-source__position' type='number' disabled={!data?.bfm_enableLinkPosition} placeholder='Eg: 1' value={data?.bfm_linkedSNo} onInput={e => linkedPositionHandler(e, i)} />;
	};

	// display formula section
	const formulaSection = (data, i) => {
		return (
			<div className='upload-source__formula'>
				<span>{data?.bfm_formula}</span>
				<div className='upload-source__imgs'>
					{data?.bfm_formula && <img src={Images.deleteGrey} alt='delete' width='18px' height='18px' onClick={() => deleteFormula(i)} />}
					<img src={Images.expand} alt='delete' width='18px' height='18px' onClick={() => setFormulaIndex(i)} />
				</div>
			</div>
		);
	};

	// deleting formula
	const deleteFormula = i => {
		setCreateObj(prevState => {
			const data = Object.assign({}, prevState);
			data.bfm_uploadDetails[i].bfm_formula = '';
			return data;
		});
	};

	// ToolTip for copy and delete row
	const handleToolTip = (index, type, list) => {
		setCreateObj(prevState => {
			const data = Object.assign({}, prevState);
			if (type === 'copy') {
				data.bfm_uploadDetails.splice(index, 0, list);
			} else if (type === 'delete') {
				data.bfm_uploadDetails.splice(index, 1);
			}
			data.bfm_uploadDetails = data.bfm_uploadDetails?.map((el, i) => ({ ...el, bfm_serialNumber: `#${i + 1}`, id: i }));
			return data;
		});
	};

	const copyToolTip = (i, data) => {
		return (
			<div className='upload-source__tooltip'>
				<span onClick={() => handleToolTip(i, 'copy', data)}>
					<img src={Images?.copyIcon} alt='copy' />
				</span>
				<span onClick={() => handleToolTip(i, 'delete', data)}>
					<img src={Images?.delete} alt='delete' />
				</span>
			</div>
		);
	};

	const body = useMemo(
		() =>
			createObj?.bfm_uploadDetails?.map((data, i) => (
				<Fragment key={i}>
					<tr>
						<td>
							{copyToolTip(i, data)}
							{data?.bfm_serialNumber}
						</td>
						{tableHeaders?.map((header, j) => header?.key !== 'bfm_serialNumber' && <td key={j}>{displayFields(data, header, i)}</td>)}
					</tr>
				</Fragment>
			)),
		[createObj, baseData.factList]
	);

	const onCloseHandler = async e => {
		setAddNewFactPopup(false);
	};

	return (
		<>
			<div id='source-table' className='upload-source'>
				<div className='upload-source__header'>
					<h4>Uploaded data</h4>
				</div>
				<table className='upload-source__table'>
					<thead>
						<tr>{headers}</tr>
					</thead>
					<tbody>{body}</tbody>
				</table>
			</div>
			<Popup onClose={() => setFormulaIndex(null)} popupState={formulaIndex !== null}>
				<TrailFormula />
			</Popup>
			<Popup onClose={() => setAddNewFactPopup(false)} popupState={isInteger(addNewFactPopup)}>
				<AddNewFact onClose={e => onCloseHandler(e)} index={addNewFactPopup} saveAddedFact={e => handleSelectFact(e?.data, e?.index)} />
			</Popup>
		</>
	);
};

export default UploadTable;
